import axios from 'axios';
import {useEffect, useState} from 'react';
import {BACKEND_URL} from 'config';

const useAxiosInterceptor = () => {
  const [hydrated, setHydrated] = useState<boolean>(false);

  useEffect(() => {
    axios.interceptors.request.use(async request => {
      const baseURL = `${BACKEND_URL}/api/v2`;
      return {
        ...request,
        baseURL,
        validateStatus: (_status: number) => true,
      };
    });

    axios.interceptors.response.use(async response => {
      return response;
    });

    setHydrated(true);
  }, []);

  return {hydrated};
};

export default useAxiosInterceptor;
